import { itemList } from './itemList';

export const itemGroup = {
  teachings_of_freedom: {
    name: 'Freedom',
    items: [itemList.teachings_of_freedom, itemList.guide_to_freedom, itemList.philosophies_of_freedom],
    type: 'book',
  },
  teachings_of_ballad: {
    name: 'Ballad',
    items: [itemList.teachings_of_ballad, itemList.guide_to_ballad, itemList.philosophies_of_ballad],
    type: 'book',
  },
  teachings_of_gold: {
    name: 'Gold',
    items: [itemList.teachings_of_gold, itemList.guide_to_gold, itemList.philosophies_of_gold],
    type: 'book',
  },
  teachings_of_resistance: {
    name: 'Resistance',
    items: [itemList.teachings_of_resistance, itemList.guide_to_resistance, itemList.philosophies_of_resistance],
    type: 'book',
  },
  teachings_of_diligence: {
    name: 'Diligence',
    items: [itemList.teachings_of_diligence, itemList.guide_to_diligence, itemList.philosophies_of_diligence],
    type: 'book',
  },
  teachings_of_prosperity: {
    name: 'Prosperity',
    items: [itemList.teachings_of_prosperity, itemList.guide_to_prosperity, itemList.philosophies_of_prosperity],
    type: 'book',
  },
  teachings_of_transience: {
    name: 'Transience',
    items: [itemList.teachings_of_transience, itemList.guide_to_transience, itemList.philosophies_of_transience],
    type: 'book',
  },
  teachings_of_elegance: {
    name: 'Elegance',
    items: [itemList.teachings_of_elegance, itemList.guide_to_elegance, itemList.philosophies_of_elegance],
    type: 'book',
  },
  teachings_of_light: {
    name: 'Light',
    items: [itemList.teachings_of_light, itemList.guide_to_light, itemList.philosophies_of_light],
    type: 'book',
  },
  teachings_of_admonition: {
    name: 'Admonition',
    items: [itemList.teachings_of_admonition, itemList.guide_to_admonition, itemList.philosophies_of_admonition],
    type: 'book',
  },
  teachings_of_ingenuity: {
    name: 'Ingenuity',
    items: [itemList.teachings_of_ingenuity, itemList.guide_to_ingenuity, itemList.philosophies_of_ingenuity],
    type: 'book',
  },
  teachings_of_praxis: {
    name: 'Praxis',
    items: [itemList.teachings_of_praxis, itemList.guide_to_praxis, itemList.philosophies_of_praxis],
    type: 'book',
  },
  teachings_of_glory: {
    name: 'Glory',
    items: [itemList.teachings_of_glory, itemList.guide_to_praxis, itemList.philosophies_of_praxis],
    type: 'book',
  },
  tile_of_decarabians_tower: {
    name: 'Decarabian',
    items: [
      itemList.tile_of_decarabians_tower,
      itemList.debris_of_decarabians_city,
      itemList.fragment_of_decarabians_epic,
      itemList.scattered_piece_of_decarabians_dream,
    ],
    type: 'weapon',
  },
  luminous_sands_from_guyun: {
    name: 'Guyun',
    items: [
      itemList.luminous_sands_from_guyun,
      itemList.lustrous_stone_from_guyun,
      itemList.relic_from_guyun,
      itemList.divine_body_from_guyun,
    ],
    type: 'weapon',
  },
  boreal_wolfs_milk_tooth: {
    name: 'Boreal Wolf',
    items: [
      itemList.boreal_wolfs_milk_tooth,
      itemList.boreal_wolfs_cracked_tooth,
      itemList.boreal_wolfs_broken_fang,
      itemList.boreal_wolfs_nostalgia,
    ],
    type: 'weapon',
  },
  mist_veiled_lead_elixir: {
    name: 'Mist Veiled Elixir',
    items: [
      itemList.mist_veiled_lead_elixir,
      itemList.mist_veiled_mercury_elixir,
      itemList.mist_veiled_gold_elixir,
      itemList.mist_veiled_primo_elixir,
    ],
    type: 'weapon',
  },
  fetters_of_the_dandelion_gladiator: {
    name: 'Dandelion Gladiator',
    items: [
      itemList.fetters_of_the_dandelion_gladiator,
      itemList.chains_of_the_dandelion_gladiator,
      itemList.shackles_of_the_dandelion_gladiator,
      itemList.dream_of_the_dandelion_gladiator,
    ],
    type: 'weapon',
  },
  grain_of_aerosiderite: {
    name: 'Aerosiderite',
    items: [
      itemList.grain_of_aerosiderite,
      itemList.piece_of_aerosiderite,
      itemList.bit_of_aerosiderite,
      itemList.chunk_of_aerosiderite,
    ],
    type: 'weapon',
  },
  coral_branch_of_a_distant_sea: {
    name: 'Distant Sea',
    items: [
      itemList.coral_branch_of_a_distant_sea,
      itemList.jeweled_branch_of_a_distant_sea,
      itemList.jade_branch_of_a_distant_sea,
      itemList.golden_branch_of_a_distant_sea,
    ],
    type: 'weapon',
  },
  narukamis_wisdom: {
    name: 'Narukami',
    items: [itemList.narukamis_wisdom, itemList.narukamis_joy, itemList.narukamis_affection, itemList.narukamis_valor],
    type: 'weapon',
  },
  mask_of_the_wicked_lieutenant: {
    name: 'Mask',
    items: [
      itemList.mask_of_the_wicked_lieutenant,
      itemList.mask_of_the_tigers_bite,
      itemList.mask_of_the_one_horned,
      itemList.mask_of_the_kijin,
    ],
    type: 'weapon',
  },
  echo_of_scorching_might: {
    name: 'Scorching Might',
    items: [
      itemList.echo_of_scorching_might,
      itemList.remnant_glow_of_scorching_might,
      itemList.dream_of_scorching_might,
      itemList.olden_days_of_scorching_might,
    ],
    type: 'weapon',
  },
  copper_talisman_of_the_forest_dew: {
    name: 'Forest Dew',
    items: [
      itemList.copper_talisman_of_the_forest_dew,
      itemList.iron_talisman_of_the_forest_dew,
      itemList.silver_talisman_of_the_forest_dew,
      itemList.golden_talisman_of_the_forest_dew,
    ],
    type: 'weapon',
  },
  oasis_gardens_reminiscence: {
    name: 'Oasis Garden',
    items: [
      itemList.oasis_gardens_reminiscence,
      itemList.oasis_gardens_kindness,
      itemList.oasis_gardens_mourning,
      itemList.oasis_gardens_truth,
    ],
    type: 'weapon',
  },
  agnidus_agate_sliver: {
    name: 'Agnidus Agate',
    items: [
      itemList.agnidus_agate_sliver,
      itemList.agnidus_agate_fragment,
      itemList.agnidus_agate_chunk,
      itemList.agnidus_agate_gemstone,
    ],
    type: 'ascension_gem',
  },
  brilliant_diamond_sliver: {
    name: 'Brilliant Diamond',
    items: [
      itemList.brilliant_diamond_sliver,
      itemList.brilliant_diamond_fragment,
      itemList.brilliant_diamond_chunk,
      itemList.brilliant_diamond_gemstone,
    ],
    type: 'ascension_gem',
  },
  prithiva_topaz_sliver: {
    name: 'Prithiva Topaz',
    items: [
      itemList.prithiva_topaz_sliver,
      itemList.prithiva_topaz_fragment,
      itemList.prithiva_topaz_chunk,
      itemList.prithiva_topaz_gemstone,
    ],
    type: 'ascension_gem',
  },
  shivada_jade_sliver: {
    name: 'Shivada Jade',
    items: [
      itemList.shivada_jade_sliver,
      itemList.shivada_jade_fragment,
      itemList.shivada_jade_chunk,
      itemList.shivada_jade_gemstone,
    ],
    type: 'ascension_gem',
  },
  vajrada_amethyst_sliver: {
    name: 'Vajrada Amethyst',
    items: [
      itemList.vajrada_amethyst_sliver,
      itemList.vajrada_amethyst_fragment,
      itemList.vajrada_amethyst_chunk,
      itemList.vajrada_amethyst_gemstone,
    ],
    type: 'ascension_gem',
  },
  varunada_lazurite_sliver: {
    name: 'Varunada Lazurite',
    items: [
      itemList.varunada_lazurite_sliver,
      itemList.varunada_lazurite_fragment,
      itemList.varunada_lazurite_chunk,
      itemList.varunada_lazurite_gemstone,
    ],
    type: 'ascension_gem',
  },
  vayuda_turquoise_sliver: {
    name: 'Vayuda Turquoise',
    items: [
      itemList.vayuda_turquoise_sliver,
      itemList.vayuda_turquoise_fragment,
      itemList.vayuda_turquoise_chunk,
      itemList.vayuda_turquoise_gemstone,
    ],
    type: 'ascension_gem',
  },
  nagadus_emerald_sliver: {
    name: 'Nagadus Emerald',
    items: [
      itemList.nagadus_emerald_sliver,
      itemList.nagadus_emerald_fragment,
      itemList.nagadus_emerald_chunk,
      itemList.nagadus_emerald_gemstone,
    ],
    type: 'ascension_gem',
  },
  juvenile_jade: {
    name: 'Juvenile Jade',
    items: [itemList.juvenile_jade],
    type: 'ascension_gem',
  },
  chaos_device: {
    name: 'Chaos',
    items: [itemList.chaos_device, itemList.chaos_circuit, itemList.chaos_core],
  },
  damaged_mask: {
    name: 'Mask',
    items: [itemList.damaged_mask, itemList.stained_mask, itemList.ominous_mask],
  },
  dead_ley_line_branch: {
    name: 'Dead Ley Line',
    items: [itemList.dead_ley_line_branch, itemList.dead_ley_line_leaves, itemList.ley_line_sprouts],
  },
  divining_scroll: {
    name: 'Scroll',
    items: [itemList.divining_scroll, itemList.sealed_scroll, itemList.forbidden_curse_scroll],
  },
  firm_arrowhead: {
    name: 'Arrowhead',
    items: [itemList.firm_arrowhead, itemList.sharp_arrowhead, itemList.weathered_arrowhead],
  },
  fragile_bone_shard: {
    name: 'Bone Shard',
    items: [itemList.fragile_bone_shard, itemList.sturdy_bone_shard, itemList.fossilized_bone_shard],
  },
  heavy_horn: {
    name: 'Horn',
    items: [itemList.heavy_horn, itemList.black_bronze_horn, itemList.black_crystal_horn],
  },
  hunters_sacrificial_knife: {
    name: 'Knife',
    items: [
      itemList.hunters_sacrificial_knife,
      itemList.agents_sacrificial_knife,
      itemList.inspectors_sacrificial_knife,
    ],
  },
  mist_grass_pollen: {
    name: 'Mist Grass',
    items: [itemList.mist_grass_pollen, itemList.mist_grass, itemList.mist_grass_wick],
  },
  recruits_insignia: {
    name: 'Insignia',
    items: [itemList.recruits_insignia, itemList.sergeants_insignia, itemList.lieutenants_insignia],
  },
  slime_condensate: {
    name: 'Slime',
    items: [itemList.slime_condensate, itemList.slime_secretions, itemList.slime_concentrate],
  },
  treasure_hoarder_insignia: {
    name: 'Treasure Hoarder Insignia',
    items: [itemList.treasure_hoarder_insignia, itemList.silver_raven_insignia, itemList.golden_raven_insignia],
  },
  whopperflower_nectar: {
    name: 'Nectar',
    items: [itemList.whopperflower_nectar, itemList.shimmering_nectar, itemList.energy_nectar],
  },
  chaos_gear: {
    name: 'Chaos Gear',
    items: [itemList.chaos_gear, itemList.chaos_axis, itemList.chaos_oculus],
  },
  old_handguard: {
    name: 'Hanguard',
    items: [itemList.old_handguard, itemList.kageuchi_handguard, itemList.famed_handguard],
  },
  dismal_prism: {
    name: 'Prism',
    items: [itemList.dismal_prism, itemList.crystal_prism, itemList.polarizing_prism],
  },
  concealed_claw: {
    name: 'Concealed Claw',
    items: [itemList.concealed_claw, itemList.concealed_unguis, itemList.concealed_talon],
  },
  spectral_husk: {
    name: 'Spectral',
    items: [itemList.spectral_husk, itemList.spectral_heart, itemList.spectral_nucleus],
  },
  gloomy_statuette: {
    name: 'Statuette',
    items: [itemList.gloomy_statuette, itemList.dark_statuette, itemList.deathly_statuette],
  },
  fungal_spores: {
    name: 'Spores',
    items: [itemList.fungal_spores, itemList.luminescent_pollen, itemList.crystalline_cyst_dust],
  },
  inactivated_fungal_nucleus: {
    name: 'Fungal Nucleus',
    items: [itemList.inactivated_fungal_nucleus, itemList.dormant_fungal_nucleus, itemList.robust_fungal_nucleus],
  },
  chaos_storage: {
    name: 'Chaos Storage',
    items: [itemList.chaos_storage, itemList.chaos_module, itemList.chaos_bolt],
  },
  faded_red_satin: {
    name: 'Satin',
    items: [itemList.faded_red_satin, itemList.trimmed_red_silk, itemList.rich_red_brocade],
  },
  damaged_prism: {
    name: 'Damaged Prism',
    items: [itemList.damaged_prism, itemList.turbid_prism, itemList.radiant_prism],
  },
  teachings_of_order: {
    name: 'Order',
    items: [itemList.teachings_of_order, itemList.guide_to_order, itemList.philosophies_of_order],
    type: 'book',
  },
  teachings_of_equity: {
    name: 'Equity',
    items: [itemList.teachings_of_equity, itemList.guide_to_equity, itemList.philosophies_of_equity],
    type: 'book',
  },
  teachings_of_justice: {
    name: 'Justice',
    items: [itemList.teachings_of_justice, itemList.guide_to_justice, itemList.philosophies_of_justice],
    type: 'book',
  },
  teachings_of_contention: {
    name: 'Contention',
    items: [itemList.teachings_of_contention, itemList.guide_to_contention, itemList.philosophies_of_contention],
    type: 'book',
  },
  teachings_of_conflict: {
    name: 'Conflict',
    items: [itemList.teachings_of_conflict, itemList.guide_to_conflict, itemList.philosophies_of_conflict],
    type: 'book',
  },
  teachings_of_kindling: {
    name: 'Kindling',
    items: [itemList.teachings_of_kindling, itemList.guide_to_kindling, itemList.philosophies_of_kindling],
    type: 'book',
  },
  teachings_of_moonlight: {
    name: 'Moonlight',
    items: [itemList.teachings_of_moonlight, itemList.guide_to_moonlight, itemList.philosophies_of_moonlight],
    type: 'book',
  },
  teachings_of_vagrancy: {
    name: 'Vagrancy',
    items: [itemList.teachings_of_vagrancy, itemList.guide_to_vagrancy, itemList.philosophies_of_vagrancy],
    type: 'book',
  },
  teachings_of_elysium: {
    name: 'Elysium',
    items: [itemList.teachings_of_elysium, itemList.guide_to_elysium, itemList.philosophies_of_elysium],
    type: 'book',
  },
  teachings_of_charity: {
    name: 'Charity',
    items: [itemList.teachings_of_charity, itemList.guide_to_charity, itemList.philosophies_of_charity],
    type: 'book',
  },
  teachings_of_fortitude: {
    name: 'Fortitude',
    items: [itemList.teachings_of_fortitude, itemList.guide_to_fortitude, itemList.philosophies_of_fortitude],
    type: 'book',
  },
  shard_of_a_shattered_will: {
    name: 'Will',
    items: [itemList.shard_of_a_shattered_will, itemList.locus_of_a_clear_will, itemList.sigil_of_a_striding_will],
  },
  blazing_sacrificial_hearts_terror: {
    name: 'Blazing Sacrificial Heart',
    items: [
      itemList.blazing_sacrificial_hearts_terror,
      itemList.blazing_sacrificial_hearts_hesitance,
      itemList.blazing_sacrificial_hearts_resolve,
      itemList.blazing_sacrificial_hearts_splendor,
    ],
    type: 'weapon',
  },
  axis_of_the_secret_source: {
    name: 'Secret Source',
    items: [
      itemList.axis_of_the_secret_source,
      itemList.sheath_of_the_secret_source,
      itemList.heart_of_the_secret_source,
    ],
  },
  night_winds_mystic_consideration: {
    name: 'Night Winds Mystic',
    items: [
      itemList.night_winds_mystic_consideration,
      itemList.night_winds_mystic_premonition,
      itemList.night_winds_mystic_augury,
      itemList.night_winds_mystic_revelation,
    ],
    type: 'weapon',
  },
  delirious_decadence_of_the_sacred_lord: {
    name: 'Night Winds Mystic',
    items: [
      itemList.delirious_decadence_of_the_sacred_lord,
      itemList.delirious_desolation_of_the_sacred_lord,
      itemList.delirious_demeanor_of_the_sacred_lord,
      itemList.delirious_divinity_of_the_sacred_lord,
    ],
    type: 'weapon',
  },
};
